import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  ADD_QUANTITY_WITH_NUMBER,
  RESET_CART,
} from "../actions/action-types/cart-actions";

export const CATALOG = [
  {
    id: 1,
    title: "RNA Made Simple",
    subtitle: "The Essential Guide to Extraction",
    price: 29.0,
    image: "../../assets/img/shop/item1.jpg",
    imageHover: "../../assets/img/shop/item1-hover.jpg",
  },
];

const computeTotal = (items) =>
  items.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0);

const initialState = {
  catalog: CATALOG,
  addedItems: [],
  total: 0,
  shipping: 0,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const product = state.catalog.find((item) => item.id === action.id);
      if (!product) return state;

      const existing = state.addedItems.find((item) => item.id === action.id);
      const addedItems = existing
        ? state.addedItems.map((item) =>
            item.id === action.id
              ? { ...item, quantity: (item.quantity || 1) + 1 }
              : item
          )
        : [...state.addedItems, { ...product, quantity: 1 }];

      return { ...state, addedItems, total: computeTotal(addedItems) };
    }

    case REMOVE_ITEM: {
      const addedItems = state.addedItems.filter((item) => item.id !== action.id);
      return { ...state, addedItems, total: computeTotal(addedItems) };
    }

    case SUB_QUANTITY: {
      const addedItems = state.addedItems
        .map((item) =>
          item.id === action.id
            ? { ...item, quantity: Math.max((item.quantity || 1) - 1, 0) }
            : item
        )
        .filter((item) => item.quantity > 0);

      return { ...state, addedItems, total: computeTotal(addedItems) };
    }

    case ADD_QUANTITY: {
      const addedItems = state.addedItems.map((item) =>
        item.id === action.id
          ? { ...item, quantity: (item.quantity || 1) + 1 }
          : item
      );

      return { ...state, addedItems, total: computeTotal(addedItems) };
    }

    case ADD_QUANTITY_WITH_NUMBER: {
      const product = state.catalog.find((item) => item.id === action.id);
      if (!product) return state;

      const existing = state.addedItems.find((item) => item.id === action.id);
      const addedItems = existing
        ? state.addedItems.map((item) =>
            item.id === action.id ? { ...item, quantity: action.qty } : item
          )
        : [...state.addedItems, { ...product, quantity: action.qty }];

      return { ...state, addedItems, total: computeTotal(addedItems) };
    }

    case RESET_CART:
      return { ...state, addedItems: [], total: 0, shipping: 0 };

    default:
      return state;
  }
};

export default cartReducer;
